import Vue from 'vue';

export function search (params) {
  return Vue.axios({
    url: '/api/search',
    method: 'get',
    params: params
  })
}


export function searchHistory (id) {
  return Vue.axios({
    url: '/api/search/history/' + id,
    method: 'DELETE',
  })
}

export function clearSearchHistory () {
  return Vue.axios({
    url: '/api/search/history/clear',
    method: 'POST',
  })
}

export function searchResult (params) {
  return Vue.axios({
    url: '/api/search/result',
    method: 'get',
    params: params
  })
}

export function favoritesList () {
  return Vue.axios({
    url: '/api/search/favorites',
    method: 'get'
  })
}

export function invalidFavoritesList () {
  return Vue.axios({
    url: '/api/search/favorites/invalid',
    method: 'get'
  })
}

export function addFavorite (data) {
  return Vue.axios({
    url: '/api/search/favorites/add',
    method: 'post',
    data: data
  })
}

export function removeFavorite (id) {
  return Vue.axios({
    url: '/api/search/favorites/' + encodeURIComponent(id),
    method: 'DELETE'
  })
}

export function clearFavorites () {
  return Vue.axios({
    url: '/api/search/favorites/clear',
    method: 'post'
  })
}

export function clearInvalidFavorites () {
  return Vue.axios({
    url: '/api/search/favorites/clearInvalid',
    method: 'post'
  })
}
